import React, { useCallback, useState } from "react";
import _ from "lodash";

const ArchiveAPTForm = ({ handleArchiveAPT, handleCancelArchiveAPT, activeCa, mode = "archive" }) => {
  const [isArchiving, setIsArchiving] = useState(false);
  const [archiveError, setArchiveError] = useState(null);
  const isUnarchive = mode === "unarchive";
  const generateAPTInfo = useCallback(() => {
    if (!activeCa) {
      return [];
    }
    const { firstName: clientFirstName = "", lastName: clientLastName = "" } = _.get(activeCa, "client") || {};
    const { name: clinicName = "" } = _.get(activeCa, "clinic") || {};
    const { firstName: practitionerFirstName = "", lastName: practitionerLastName = "" } =
      _.get(activeCa, "practitioner") || {};

    return [
      {
        label: "ID",
        value: activeCa.id,
      },
      {
        label: "Client",
        value: `${clientFirstName} ${clientLastName}`,
      },
      {
        label: "Clinic",
        value: clinicName,
      },
      {
        label: "Case Manager",
        value: `${practitionerFirstName} ${practitionerLastName}`,
      },
    ];
  }, [activeCa]);

  return (
    <>
      <h2 className="is-size-7 menu-label">{isUnarchive ? "Unarchive this workflow?" : "Archive this workflow?"}</h2>
      <table className="table">
        <thead>
          <tr>
            {generateAPTInfo().map(({ label, value }) => (
              <th className="is-small mr-3 apt-info-label" key={label}>
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {generateAPTInfo().map(({ label, value }) => (
              <td className="is-small mr-3 apt-info-label" key={value}>
                {value}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
      <div className="field is-grouped is-grouped-right">
        <p className="control">
          <button
            className={`button is-primary is-radiusless is-small ${isArchiving ? "is-loading" : ""}`}
            onClick={async () => {
              setIsArchiving(true);
              setArchiveError(null);
              try {
                await handleArchiveAPT();
              } catch (error) {
                setArchiveError(
                  isUnarchive
                    ? "Failed to unarchive workflow. Please try again."
                    : "Failed to archive workflow. Please try again."
                );
              } finally {
                setIsArchiving(false);
              }
            }}
          >
            Yes
          </button>
        </p>
        <p className="control">
          <button
            className="button is-light is-radiusless is-small"
            onClick={handleCancelArchiveAPT}
            disabled={isArchiving}
          >
            Cancel
          </button>
        </p>
      </div>
      {archiveError && <p className="help is-danger">{archiveError}</p>}
    </>
  );
};

export default ArchiveAPTForm;
